'use strict';

import React, {PropTypes} from 'react';
import Modal from 'react-modal';

export default class IstDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            modal_type: props.modal_type,
            header_title: 'エラー',
            primary_button_label: 'はい',
            cancel_button_label: 'キャンセル',
            close_button_label: '閉じる',
            message_json: {
                "response": "Error",
                "code": '0000',
                "message": 'エラーにより処理が中断されました'
            },
            requiredFunc:props.requiredFunc
        }
    }

    toggleAlertModal() {
        this.setState({open: !this.state.open})
    }


    render() {

        let modal_footer;
        switch (this.state.modal_type) {
            case 'error':
                console.log('error')
                modal_footer = (
                    <div className="modal__footer flex-box-horizontal-nowrap"
                         style={{left:'50%',marginLeft:'-50px',bottom:'0',position:'absolute'}}>
                        <div className="button_wrapper flex-col-auto" type='button'
                             onClick={this.toggleAlertModal.bind(this)}>
                            <button className="button">{this.state.close_button_label}</button>
                        </div>
                    </div>
                )
                break;

            case 'error_func':
                console.log('error_func')
                modal_footer = (
                    <div className="modal__footer flex-box-horizontal-nowrap"
                         style={{left:'50%',marginLeft:'-50px',bottom:'0',position:'absolute'}}>
                        <div className="button_wrapper flex-col-auto" type='button'
                             onClick={this.state.requiredFunc.bind(this)}>
                            <button className="button">{this.state.close_button_label}</button>
                        </div>
                    </div>
                )
                break;


            case 'confirm':
                console.log('confirm')
                modal_footer = (
                    <div className="modal__footer flex-box-horizontal-nowrap"
                         style={{left:'50%',marginLeft:'-50px',bottom:'0',position:'absolute'}}>
                        <div className="button_wrapper flex-col-auto" type='button'
                             onClick={this.toggleAlertModal.bind(this)}>
                            <button className="button">{this.state.cancel_button_label}</button>
                        </div>
                        <div className="button_wrapper flex-col-auto" type='button'
                             onClick={this.state.requiredFunc.bind(this)}>
                            <button className="button">{this.state.primary_button_label}</button>
                        </div>
                    </div>
                )
                break;
            default:
                modal_footer = (
                    <div className="modal__footer flex-box-horizontal-nowrap"
                         style={{left:'50%',marginLeft:'-50px',bottom:'0',position:'absolute'}}>
                        <div className="button_wrapper flex-col-auto" type='button'
                             onClick={this.toggleAlertModal.bind(this)}>
                            <button className="button">{this.state.close_button_label}</button>
                        </div>
                    </div>
                )
        }

        const customStyles = {
            overlay: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                position:'fixed',
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                WebkitBoxPack:'center',
                WebkitJustifyContent:'center',
                msFlexPack:'center',
                WebkitBoxAlign:'center',
                WebkitAlignItems:'center',
                msFlexAlign:'center'
            },
            content: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                position: 'none',
                width: '100%',
                height: '50%',
                wordWrap: 'break-word',
                overflow: 'scroll',
                borderTop: '10px solid #01579B',
                borderBottom: '10px solid #01579B',
                borderRight: 'none',
                borderLeft: 'none',
                WebkitOverflowScrolling: 'touch'
            }
        };

        return (
            <Modal
                isOpen={this.state.open}
                onRequestClose={this.toggleAlertModal.bind(this)}
                className="error_dialog_modal"
                style={customStyles}>
                <div className='modal__wrapper'>
                    <h4 className="modal__header">
                        {this.state.header_title}
                    </h4>
                    <div className="modal__body" style={{position:'relative',height:'auto'}}>
                        <span>{this.state.message_json.message} <br/> {this.state.message_json.code}</span>
                    </div>
                    {modal_footer}
                </div>
            </Modal>
        )
    }

}

IstDialog.defaultProps = {
    modal_type:'error'
};


// WEBPACK FOOTER //
// ./src/jsx/common/components/dialog.jsx